import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Menu, MenuItem, Button, Box } from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropDown";
import CheckIcon from "@mui/icons-material/Check";
import { ReactComponent as Exercise } from "../../assets/actionbar/exercise_black.svg";
import { ReactComponent as Care } from "../../assets/actionbar/care_black.svg";
import { ReactComponent as User } from "../../assets/actionbar/user_black.svg";
import ShareIcon from "@mui/icons-material/Share";
import ChangeCircleOutlinedIcon from "@mui/icons-material/ChangeCircleOutlined";
import NotListedLocationIcon from "@mui/icons-material/NotListedLocation";
import { ThemeContext } from "../../context/ThemeContext";
import GroupWorkIcon from "@mui/icons-material/GroupWork";
import useMediaQuery from "@mui/material/useMediaQuery";

export const SectionSelectbar = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const currentSection = window.location.pathname.split("/")[1];
  const currentSection1 = window.location.pathname.split("/")[2];
  const isDisable =
    currentSection === "brain" ||
    currentSection === "shoulder" ||
    currentSection === "knee" ||
    currentSection === "ankleNfoot" ||
    currentSection === "elbowNwrist" ||
    currentSection === "hip" ||
    currentSection === "jaw" ||
    currentSection === "phase_of_care" ||
    (currentSection === "spine" &&
      currentSection1 !== null &&
      currentSection1 !== undefined) ||
    (currentSection === "nervous_system" &&
      currentSection1 !== null &&
      currentSection1 !== undefined) ||
    (currentSection === "treatments" &&
      currentSection1 !== null &&
      currentSection1 !== undefined);
  const isMobile = useMediaQuery("(max-width:430px)"); // Check if screen width is less than 768px
  const isChecked =
    currentSection === "exercise" ||
    currentSection === "care-plan" ||
    currentSection === "share" ||
    currentSection === "automation" ||
    currentSection === "users" ||
    currentSection === "tutorial";
  const titleShow =
    isChecked || currentSection === "" || currentSection === "videos";
  const navigate = useNavigate();
  const { darkMode } = useContext(ThemeContext);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelection = (section) => {
    navigate(`/${section}`);
    handleClose();
  };

  return (
    <Box sx={{ display: isDisable ? "none" : "block" }}>
      <Button
        startIcon={<GroupWorkIcon />}
        endIcon={open ? <ArrowDropDownIcon /> : <ArrowDropUpIcon />}
        onClick={handleClick}
        variant="contained"
      >
        {!isMobile || titleShow ? "Sections" : ""}
      </Button>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        <MenuItem onClick={() => handleSelection("exercise")}>
          {currentSection === "exercise" ? (
            <CheckIcon style={{ marginRight: 8 }} />
          ) : (
            <Box style={{ width: isChecked ? 32 : 0 }} />
          )}
          <Exercise
            style={{
              marginRight: 16,
              filter: darkMode && "brightness(0) invert(1)",
            }}
          />
          Exercises
        </MenuItem>
        <MenuItem onClick={() => handleSelection("care-plan")}>
          {currentSection === "care-plan" ? (
            <CheckIcon style={{ marginRight: 8 }} />
          ) : (
            <Box style={{ width: isChecked ? 32 : 0 }} />
          )}
          <Care
            style={{
              marginRight: 16,
              filter: darkMode && "brightness(0) invert(1)",
            }}
          />
          Care Plan
        </MenuItem>
        <MenuItem onClick={() => handleSelection("share")}>
          {currentSection === "share" ? (
            <CheckIcon style={{ marginRight: 8 }} />
          ) : (
            <Box style={{ width: isChecked ? 32 : 0 }} />
          )}
          <ShareIcon style={{ marginRight: 16 }} />
          Share
        </MenuItem>
        <MenuItem onClick={() => handleSelection("automation")}>
          {currentSection === "automation" ? (
            <CheckIcon style={{ marginRight: 8 }} />
          ) : (
            <Box style={{ width: isChecked ? 32 : 0 }} />
          )}
          <ChangeCircleOutlinedIcon style={{ marginRight: 16 }} />
          Automation
        </MenuItem>
        <MenuItem onClick={() => handleSelection("tutorial")}>
          {currentSection === "tutorial" ? (
            <CheckIcon style={{ marginRight: 8 }} />
          ) : (
            <Box style={{ width: isChecked ? 32 : 0 }} />
          )}
          <NotListedLocationIcon style={{ marginRight: 16 }} />
          Tutorials
        </MenuItem>
        <MenuItem onClick={() => handleSelection("users")}>
          {currentSection === "users" ? (
            <CheckIcon style={{ marginRight: 8 }} />
          ) : (
            <Box style={{ width: isChecked ? 32 : 0 }} />
          )}
          <User
            style={{
              marginRight: 16,
              filter: darkMode && "brightness(0) invert(1)",
            }}
          />
          Users
        </MenuItem>
      </Menu>
    </Box>
  );
};
